export const procedureTypeSchema = {
  type: "object",
  required: ["name", "id"],
  properties: {
    id: { type: "number" },
    name: { type: "string" },
    description: { type: ["string"] },
    color: { type: ["string"] },
    icon: { type: ["string"] },
    selected_icon: { type: ["string"] },
    is_deleted: { type: ["boolean", "null"] },
    created_at: { type: ["string"] },
    updated_at: { type: ["string", "null"] },
    created_by: { type: ["string"] },
    updated_by: { type: ["string", "null"] },
  },
  additionalProperties: false,
};

export const procedureTypesResponseSchema = {
  type: "object",
  additionalProperties: false,
  properties: {
    count: { type: "number" },
    items: {
      type: ["array"],
      items: procedureTypeSchema,
    },
  },
};

export const procedureTypeRequestSchema = {
  type: "object",
  properties: {
    params: {
      properties: {
        name: { type: "string" },
      },
      additionalProperties: false,
    },
  },
  additionalProperties: false,
};
